export const merchantNamespace = 'mch';
export const defaultMerchantNamespace = merchantNamespace + '.default';
export const selectedMerchantNamespace = merchantNamespace + '.selected';
